/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService
 */

export const startProgressRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'startProgress',
  auth: 'app',
  fingerprint: 'pry_YHlG_fv8RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markContentCompletedRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'markContentCompleted',
  auth: 'app',
  fingerprint: 'VEQh-phtbw78RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserProgressVisibilityRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'setUserProgressVisibility',
  auth: 'app',
  fingerprint: 'SkOnRzCd9Kj8RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteExerciseProgressRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'deleteExerciseProgress',
  auth: 'app',
  fingerprint: '-ME8MayF-7_8RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createSwapRequestRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'createSwapRequest',
  auth: 'app',
  fingerprint: 'gCxNkT9QFbr8RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const confirmSwapRequestRpc = {
  serviceName: 'com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService',
  rpcName: 'confirmSwapRequest',
  auth: 'app',
  fingerprint: 'xMFNFWPHwLz8RvOdJozGO5D18J9lvcSv',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};